import { type ConnectionModalProps } from "@components/molecules/Modal/ConnectionModal";
import { type EventButtonCreateModalProps } from "@components/molecules/Modal/EventButtonCreateModal";
import { type FAQOrderManagementModalProps } from "@components/molecules/Modal/FAQOrderManagementModal";
import { type OneButtonModalProps } from "@components/molecules/Modal/OneButtonModal";
import { type OrderManagementModalProps } from "@components/molecules/Modal/OrderManagementModal";
import { type ManualOrderManagementModalProps } from "@components/molecules/Modal/ManualOrderManagementModal";
import { type ReasonEditModalProps } from "@components/molecules/Modal/ReasonEditModal";
import { type ReasonModificationModalProps } from "@components/molecules/Modal/ReasonModificationModal";
import { type TermsEditorModalProps } from "@components/molecules/Modal/TermsEditorModal";
import { type TwoButtonModalProps } from "@components/molecules/Modal/TwoButtonModal";
import { create } from "zustand";

export type ModalType =
    | "TwoButtonModal"
    | "OrderManagementModal"
    | "ConnectionModal"
    | "OneButtonModal"
    | "TermsEditorModal"
    | "ReasonEditModal"
    | "ReasonModificationModal"
    | "EventButtonCreateModal"
    | "ManualOrderManagementModal"
    | "FAQOrderManagementModal"
    | null;

export type GlobalModalType = {
    modalType: ModalType;
    modalProps:
        | TwoButtonModalProps
        | OneButtonModalProps
        | ConnectionModalProps
        | ReasonEditModalProps
        | ReasonModificationModalProps
        | EventButtonCreateModalProps
        | TermsEditorModalProps
        | OrderManagementModalProps
        | ManualOrderManagementModalProps
        | FAQOrderManagementModalProps
        | null;
};

type GlobalModalStore = {
    globalModal: GlobalModalType;
    setGlobalModal: (modal: GlobalModalType) => void;
    hideGlobalModal: () => void;
};

const initialData = {
    globalModal: {
        modalType: null,
        modalProps: null,
    },
};

const useGlobalModalStore = create<GlobalModalStore>(set => ({
    ...initialData,
    setGlobalModal: modal => set({ globalModal: modal }),
    hideGlobalModal: () =>
        set({
            globalModal: {
                modalProps: null,
                modalType: null,
            },
        }),
}));

export default useGlobalModalStore;
